import React from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation
import ComingSoon from '../../../../commonComponent/ComingSoon';

function TaxManagement() {
  const navigate = useNavigate(); // Initialize useNavigate for routing

  return (
    <div>
      <div className="p-6 bg-gray-100">
        <header className="flex justify-between items-center mb-3 bg-white p-3">
          <h1 className="text-black text-xl font-bold ml-2">Finance and Accounting</h1>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/billing-invoicing')}
              className="btn "
            >
              Billing and Invoicing
            </button>
            <button
              onClick={() =>
                navigate('/dashboard/core-modules/finance/accounts-receivable-payable')
              }
              className="btn "
            >
              Accounts Receivable/Payable
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/financial-reporting')}
              className="btn "
            >
              Financial Reporting
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/tax-management')}
              className="btn text-black font-bold"
            >
              Tax Management
            </button>
            <button
              onClick={() => navigate('/dashboard/core-modules/finance/audit-logs')}
              className="btn "
            >
              Audit Logs
            </button>
          </div>
        </header>

        <ComingSoon />
      </div>
    </div>
  );
}

export default TaxManagement;

// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';

// function TaxManagement() {
//   const navigate = useNavigate();

//   return (
//     <div className="min-h-screen bg-gray-100">
//       <div className="p-6">
//         <header className="flex justify-between items-center mb-6 bg-white p-4 rounded-lg shadow-sm">
//           <h1 className="text-black text-xl font-bold">Finance and Accounting</h1>
//           <div className="flex space-x-6">
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/billing-invoicing")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Billing and Invoicing
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/accounts-receivable-payable")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Accounts Receivable/Payable
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/financial-reporting")}
//               className="text-dark-gray hover:text-black transition-colors"
//             >
//               Financial Reporting
//             </button>
//             <button
//               onClick={() => navigate("/dashboard/core-modules/finance/tax-management")}
//               className="text-black font-bold border-b-2 border-black pb-1"
//             >
//               Tax Management
//             </button>
//           </div>
//         </header>

//         <TaxManagementDashboard />
//       </div>
//     </div>
//   );
// }

// // Tax Management Component
// function TaxManagementDashboard() {
//   const [filters, setFilters] = useState({
//     month: 'april-2024',
//     region: '',
//     taxType: '',
//     status: ''
//   });

//   // Sample tax data
//   const taxData = {
//     summary: {
//       gstCollected: 15420.00,
//       vatPaid: 8920.00,
//       serviceTax: 4560.00,
//       netTaxLiability: 11060.00
//     },
//     transactions: [
//       {
//         id: 'TX-001',
//         date: '2024-04-15',
//         invoiceNumber: 'INV-001',
//         taxType: 'GST',
//         rate: 18,
//         customerSupplier: 'John Smith',
//         taxableAmount: 2500.00,
//         taxAmount: 450.00,
//         status: 'Collected',
//         type: 'Receivable'
//       },
//       {
//         id: 'TX-002',
//         date: '2024-04-16',
//         invoiceNumber: 'INV-002',
//         taxType: 'VAT',
//         rate: 12,
//         customerSupplier: 'ABC Corporation',
//         taxableAmount: 10000.00,
//         taxAmount: 1200.00,
//         status: 'Collected',
//         type: 'Receivable'
//       },
//       {
//         id: 'TX-003',
//         date: '2024-04-10',
//         invoiceNumber: 'SUPP-001',
//         taxType: 'GST',
//         rate: 18,
//         customerSupplier: 'Fresh Food Suppliers',
//         taxableAmount: 5000.00,
//         taxAmount: 900.00,
//         status: 'Paid',
//         type: 'Payable'
//       },
//       {
//         id: 'TX-004',
//         date: '2024-04-12',
//         invoiceNumber: 'INV-003',
//         taxType: 'Service Tax',
//         rate: 15,
//         customerSupplier: 'Sarah Johnson',
//         taxableAmount: 2000.00,
//         taxAmount: 300.00,
//         status: 'Collected',
//         type: 'Receivable'
//       },
//       {
//         id: 'TX-005',
//         date: '2024-04-18',
//         invoiceNumber: 'SUPP-002',
//         taxType: 'VAT',
//         rate: 12,
//         customerSupplier: 'CleanLinens Co.',
//         taxableAmount: 2666.67,
//         taxAmount: 320.00,
//         status: 'Paid',
//         type: 'Payable'
//       },
//       {
//         id: 'TX-006',
//         date: '2024-04-20',
//         invoiceNumber: 'INV-004',
//         taxType: 'GST',
//         rate: 18,
//         customerSupplier: 'Global Events Inc',
//         taxableAmount: 13888.89,
//         taxAmount: 2500.00,
//         status: 'Pending',
//         type: 'Receivable'
//       }
//     ],
//     compliance: {
//       nextFilingDue: '2024-05-30',
//       lastFilingDate: '2024-04-28',
//       filingStatus: 'Compliant',
//       upcomingDeadlines: [
//         { type: 'GST Filing', dueDate: '2024-05-30', status: 'Pending' },
//         { type: 'VAT Return', dueDate: '2024-06-15', status: 'Upcoming' },
//         { type: 'Service Tax', dueDate: '2024-05-20', status: 'Pending' }
//       ]
//     }
//   };

//   const taxRates = [
//     { type: 'GST', rate: 18, description: 'Goods and Services Tax' },
//     { type: 'VAT', rate: 12, description: 'Value Added Tax' },
//     { type: 'Service Tax', rate: 15, description: 'Service Tax on Hospitality' },
//     { type: 'Luxury Tax', rate: 5, description: 'Luxury Accommodation Tax' }
//   ];

//   const handleFilterChange = (key, value) => {
//     setFilters(prev => ({ ...prev, [key]: value }));
//   };

//   const handleGenerateTaxReport = () => {
//     console.log('Generating tax report with filters:', filters);
//     // Implementation for generating tax report
//   };

//   const handleExportReport = (format) => {
//     console.log('Exporting report in format:', format);
//     // Implementation for exporting report
//   };

//   const handleFileTaxReturn = (taxType) => {
//     console.log('Filing tax return for:', taxType);
//     // Implementation for filing tax return
//   };

//   const filteredTransactions = taxData.transactions.filter(transaction => {
//     return (
//       (filters.taxType === '' || transaction.taxType === filters.taxType) &&
//       (filters.status === '' || transaction.status === filters.status) &&
//       (filters.region === '' || true) // Region filter would be implemented based on actual data
//     );
//   });

//   const getStatusColor = (status) => {
//     switch (status) {
//       case 'Collected': return 'bg-green-100 text-green-800';
//       case 'Paid': return 'bg-blue-100 text-blue-800';
//       case 'Pending': return 'bg-yellow-100 text-yellow-800';
//       case 'Overdue': return 'bg-red-100 text-red-800';
//       default: return 'bg-gray-100 text-gray-800';
//     }
//   };

//   const getTypeColor = (type) => {
//     return type === 'Receivable'
//       ? 'bg-purple-100 text-purple-800'
//       : 'bg-orange-100 text-orange-800';
//   };

//   return (
//     <div className="bg-white rounded-lg shadow-sm p-6">
//       {/* Filters and Generate Report Button */}
//       <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mb-6 gap-4">
//         <div className="flex flex-wrap gap-4">
//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.month}
//             onChange={(e) => handleFilterChange('month', e.target.value)}
//           >
//             <option value="march-2024">March 2024</option>
//             <option value="april-2024">April 2024</option>
//             <option value="may-2024">May 2024</option>
//             <option value="q1-2024">Q1 2024</option>
//             <option value="q2-2024">Q2 2024</option>
//           </select>

//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.region}
//             onChange={(e) => handleFilterChange('region', e.target.value)}
//           >
//             <option value="">All Regions</option>
//             <option value="north">North Region</option>
//             <option value="south">South Region</option>
//             <option value="east">East Region</option>
//             <option value="west">West Region</option>
//           </select>

//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.taxType}
//             onChange={(e) => handleFilterChange('taxType', e.target.value)}
//           >
//             <option value="">All Tax Types</option>
//             <option value="GST">GST</option>
//             <option value="VAT">VAT</option>
//             <option value="Service Tax">Service Tax</option>
//             <option value="Luxury Tax">Luxury Tax</option>
//           </select>

//           <select
//             className="border border-light-gray rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
//             value={filters.status}
//             onChange={(e) => handleFilterChange('status', e.target.value)}
//           >
//             <option value="">All Status</option>
//             <option value="Collected">Collected</option>
//             <option value="Paid">Paid</option>
//             <option value="Pending">Pending</option>
//           </select>
//         </div>

//         <div className="flex space-x-2 w-full lg:w-auto">
//           <button
//             onClick={handleGenerateTaxReport}
//             className="bg-black text-white px-6 py-2 rounded-lg font-semibold hover:bg-gray-800 transition-colors flex-1 lg:flex-none"
//           >
//             Generate Tax Report
//           </button>
//           <button
//             onClick={() => handleExportReport('pdf')}
//             className="border border-light-gray text-black px-4 py-2 rounded-lg font-medium hover:bg-gray-50 transition-colors"
//             title="Export PDF"
//           >
//             <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
//             </svg>
//           </button>
//         </div>
//       </div>

//       {/* Tax Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">GST Collected</h3>
//           <p className="text-black text-2xl font-bold">${taxData.summary.gstCollected.toLocaleString()}</p>
//           <p className="text-green-600 text-sm mt-1">On track</p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">VAT Paid</h3>
//           <p className="text-black text-2xl font-bold">${taxData.summary.vatPaid.toLocaleString()}</p>
//           <p className="text-blue-600 text-sm mt-1">Within limits</p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Service Tax</h3>
//           <p className="text-black text-2xl font-bold">${taxData.summary.serviceTax.toLocaleString()}</p>
//           <p className="text-purple-600 text-sm mt-1">As expected</p>
//         </div>
//         <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//           <h3 className="text-dark-gray text-sm font-medium mb-1">Net Tax Liability</h3>
//           <p className="text-black text-2xl font-bold">${taxData.summary.netTaxLiability.toLocaleString()}</p>
//           <p className="text-orange-600 text-sm mt-1">To be paid</p>
//         </div>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
//         {/* Tax Transactions Table */}
//         <div className="lg:col-span-2">
//           <h3 className="text-black font-semibold mb-4">Tax Transactions</h3>
//           <div className="overflow-x-auto">
//             <table className="w-full">
//               <thead>
//                 <tr className="border-b border-light-gray">
//                   <th className="text-left py-3 px-4 font-semibold text-black">Date</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Invoice #</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Tax Type</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Customer/Supplier</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Amount</th>
//                   <th className="text-left py-3 px-4 font-semibold text-black">Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredTransactions.map((transaction, index) => (
//                   <tr
//                     key={transaction.id}
//                     className={`border-b border-light-gray ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
//                   >
//                     <td className="py-3 px-4 text-dark-gray">{transaction.date}</td>
//                     <td className="py-3 px-4 text-black font-medium">{transaction.invoiceNumber}</td>
//                     <td className="py-3 px-4">
//                       <div className="flex items-center space-x-2">
//                         <span className={`inline-flex items-center px-2 py-1 rounded text-xs font-medium ${getTypeColor(transaction.type)}`}>
//                           {transaction.taxType}
//                         </span>
//                         <span className="text-xs text-dark-gray">{transaction.rate}%</span>
//                       </div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div>
//                         <p className="text-black text-sm">{transaction.customerSupplier}</p>
//                         <p className="text-dark-gray text-xs">{transaction.type}</p>
//                       </div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <div className="text-right">
//                         <p className="text-black font-medium">${transaction.taxAmount.toFixed(2)}</p>
//                         <p className="text-dark-gray text-xs">on ${transaction.taxableAmount.toFixed(2)}</p>
//                       </div>
//                     </td>
//                     <td className="py-3 px-4">
//                       <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(transaction.status)}`}>
//                         {transaction.status}
//                       </span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* Tax Rates & Compliance Sidebar */}
//         <div className="space-y-6">
//           {/* Tax Rates */}
//           <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//             <h3 className="text-black font-semibold mb-4">Current Tax Rates</h3>
//             <div className="space-y-3">
//               {taxRates.map((tax, index) => (
//                 <div key={tax.type} className="flex justify-between items-center py-2 border-b border-light-gray last:border-b-0">
//                   <div>
//                     <p className="text-black font-medium">{tax.type}</p>
//                     <p className="text-dark-gray text-sm">{tax.description}</p>
//                   </div>
//                   <span className="bg-gray-100 text-black px-3 py-1 rounded-full text-sm font-medium">
//                     {tax.rate}%
//                   </span>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Upcoming Deadlines */}
//           <div className="bg-white border border-light-gray rounded-lg p-4 shadow-sm">
//             <h3 className="text-black font-semibold mb-4">Upcoming Deadlines</h3>
//             <div className="space-y-3">
//               {taxData.compliance.upcomingDeadlines.map((deadline, index) => (
//                 <div key={index} className="flex justify-between items-center py-2 border-b border-light-gray last:border-b-0">
//                   <div>
//                     <p className="text-black font-medium text-sm">{deadline.type}</p>
//                     <p className="text-dark-gray text-xs">Due: {deadline.dueDate}</p>
//                   </div>
//                   <button
//                     onClick={() => handleFileTaxReturn(deadline.type)}
//                     className="bg-black text-white px-3 py-1 rounded text-xs font-medium hover:bg-gray-800 transition-colors"
//                   >
//                     File Return
//                   </button>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Compliance Reminder Bar */}
//       <div className="bg-gray-50 rounded-lg p-4 border border-light-gray">
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//           <div className="flex items-center space-x-4">
//             <div className="flex items-center justify-center w-10 h-10 bg-green-100 rounded-full">
//               <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//             <div>
//               <h3 className="text-black font-semibold">Tax Compliance Status</h3>
//               <p className="text-dark-gray text-sm">
//                 Next Tax Filing Due: <span className="font-medium text-black">{taxData.compliance.nextFilingDue}</span>
//               </p>
//             </div>
//           </div>
//           <div className="flex space-x-2">
//             <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
//               {taxData.compliance.filingStatus}
//             </span>
//             <button className="bg-black text-white px-4 py-2 rounded-lg font-medium hover:bg-gray-800 transition-colors">
//               View Compliance Report
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default TaxManagement;
